import { useCallback, useEffect, useState } from "react";

import { MessageItem } from "@/components/cached-messages/types";

import { useApi } from "../useApi";

interface UseAdminCachedMessageByIdProps {
  messageId: string;
}

const useAdminCachedMessageById = ({
  messageId,
}: UseAdminCachedMessageByIdProps) => {
  const [message, setMessage] = useState<MessageItem>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { apiGet } = useApi({ isAdmin: true });

  const fetchCachedMessageById = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiGet<MessageItem>(
        `/admin/cached-messages/${messageId}`
      );
      if (response) {
        setMessage(response);
      } else {
        setError("Failed to load cached message");
      }
    } catch (error) {
      console.error(error);
      setError("Failed to load cached message");
    } finally {
      setLoading(false);
    }
  }, [apiGet, messageId]);

  // Run on load.
  useEffect(() => {
    fetchCachedMessageById();
  }, [fetchCachedMessageById]);

  return {
    message,
    loading,
    error,
    refresh: fetchCachedMessageById,
  };
};

export default useAdminCachedMessageById;
